import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  className?: string;
  fullWidth?: boolean;
  onClick?: () => void;
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  text,
  subtext,
  className = '',
  fullWidth = false,
  onClick
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onClick) {
      onClick();
    } else {
      const element = document.getElementById('compra');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.button onClick={handleClick} className={`
        relative group flex flex-col items-center justify-center
        bg-gradient-to-r from-blue-600 to-blue-700
        hover:from-blue-700 hover:to-blue-800
        text-white font-black uppercase tracking-wide
        py-5 px-10 rounded-2xl shadow-xl hover:shadow-2xl
        transition-all duration-300 transform hover:-translate-y-1
        border-b-4 border-blue-900 active:border-b-2 active:translate-y-0.5
        ${fullWidth ? 'w-full' : 'w-auto inline-flex'}
        ${className}
      `} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-6">
      {/* Shine effect */}
      <div className="absolute inset-0 rounded-2xl overflow-hidden" data-id="element-7">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-20 transform -skew-x-12 group-hover:translate-x-full transition-all duration-700" data-id="element-8"></div>
      </div>

      <div className="relative flex items-center gap-3 text-xl md:text-2xl" data-id="element-9">
        <span data-id="element-10">{text}</span>
        <ArrowRight className="w-6 h-6 group-hover:translate-x-2 transition-transform duration-300" data-id="element-11" />
      </div>
      {subtext && <span className="relative text-xs md:text-sm font-semibold opacity-90 mt-2 normal-case text-blue-100" data-id="element-12">
          {subtext}
        </span>}
    </motion.button>;
};